export default __webpack_public_path__ + "static/media/SideTable_Terracotta.2373eea5.png";